import { useState, useEffect } from 'react';

const STORAGE_KEY = 'nura_conversations';

// Helper function to clean data before storing
const sanitizeData = (data) => {
  const { id, title, messages, lastUpdated } = data;
  return {
    id: id || `conv-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
    title: title || `Chat ${Date.now()}`,
    messages: messages?.map(msg => ({
      role: msg.role,
      content: msg.content,
      model: msg.model,  // Add model to message structure
      timestamp: msg.timestamp || new Date().toISOString()
    })) || [],
    lastUpdated: lastUpdated || new Date().toISOString()
  };
};

export const useLocalConversations = () => {
  const [conversations, setConversations] = useState(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored).map(sanitizeData) : [];
  });

  // Save conversations to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(conversations));
  }, [conversations]);

  const addConversation = (conversation) => {
    setConversations(prev => [...prev, sanitizeData(conversation)]);
  };

  const updateConversation = (id, updatedConversation) => {
    setConversations(prev => 
      prev.map(conv => conv.id === id ? sanitizeData(updatedConversation) : conv)
    );
  };

  const deleteConversation = (id) => {
    setConversations(prev => prev.filter(conv => conv.id !== id));
  };

  return {
    conversations,
    addConversation,
    updateConversation,
    deleteConversation
  };
};